<div
  #specificContainer
  class="iu-specific-window iu-specific-window-container"
  [attr.data-cy-specific-window-name]="name">
  @if (!isModal && isLoading) {
    <p-progressBar [mode]="'indeterminate'" [showValue]="false" [styleClass]="'loading-progressbar'" [value]="0" />
  }
  @if (vcrOptional.length > 0) {
    <a class="settings" (click)="isSidebarOpen = !isSidebarOpen">
      <i aria-hidden="true" class="fas fa-cog"></i>
    </a>
  }
  <p-scrollPanel #scrollPanel [style]="{ width: '100%', height: '100%' }">
    <div class="drools-editor-options">
      <iu-input-switch-ui
        style="width: fit-content"
        [fieldValue]="buildOnSave ? 'Y' : 'N'"
        [isStandalone]="true"
        [label]="'build on save'"
        (fieldValueModified)="buildOnSave = $event === 'Y'" />
      <iu-button-ui
        [icon]="'fa fa-gears'"
        [isReadOnly]="building"
        [isStandalone]="true"
        [title]="'build'"
        (click)="build()" />
      <iu-button-ui
        [icon]="'icon-refresh3x'"
        [isReadOnly]="loading"
        [isStandalone]="true"
        [title]="'loadFiles'"
        (click)="loadFiles()" />
    </div>
    <div class="apiz-monaco-editor">
      <div #filesDiv class="apiz-monaco-editor-files" (contextmenu)="onContextMenu($event)">
        <p-tree
          #tree
          metaKeySelection="true"
          selectionMode="multiple"
          [contextMenu]="fakeCM"
          [loadingMode]="'icon'"
          [value]="files"
          [(selection)]="selection"
          (onNodeContextMenuSelect)="onTreeNodeContextMenuSelectEvent($event)"
          (onNodeExpand)="onNodeExpand($event)"
          (onNodeSelect)="handleNodeSelection($event)">
          <ng-template let-node pTemplate="input">
            <iu-input-text-ui #input [isStandalone]="true" (enterKey)="onInputEnd($event)" />
          </ng-template>
          <ng-template let-node pTemplate="default"> {{ node.label }}{{ node.data.edited() ? '*' : '' }}</ng-template>
        </p-tree>
      </div>
      <iu-monaco-editor
        [heightOptions]="{ value: '540px' }"
        [language]="'drools'"
        (editorContentChange)="onEditorContentChange($event)"
        (editorDestroy)="onEditorDestroy($event)"
        (editorReady)="onEditorReady($event)"
        (editorSave)="onEditorSave($event)" />
    </div>
    <div class="iu-specific-btn-container" [ngClass]="[shouldAddPadding ? 'shouldAddPadding' : '']">
      @if (gridViews && gridViews.length === 1 && hasInfoWindowGrid) {
        <iu-button-ui
          class="p-col-12 p-md-3 p-lg-2"
          data-cy="form-button-zoom"
          icon="fa fa-search-plus"
          label="{{ 'contextmenu.zoom' | translate }}"
          (click)="$event.preventDefault(); $event.stopPropagation(); zoomOnLineSelected()" />
      }
      <ng-template #vcrButtons />
      @if (isModal && gridViews && gridViews.length === 1 && hasInfoWindowGrid) {
        <iu-button-ui
          class="p-col-12 p-md-3 p-lg-2"
          data-cy="form-button-validate"
          label="{{ 'infodialog.ok' | translate }}"
          (click)="
            $event.preventDefault(); $event.stopPropagation(); setSelectedRowOnAutocomplete(); closeModalEmitter.emit()
          " />
      }
      @if (isModal) {
        <iu-button-ui
          btnType="alert"
          class="p-col-12 p-md-3 p-lg-2"
          icon="fa fa-ban"
          label="{{ 'process.cancel' | translate }}"
          (click)="$event.preventDefault(); $event.stopPropagation(); closeModalEmitter.emit()" />
      }
    </div>
  </p-scrollPanel>
  <p-sidebar
    position="right"
    styleClass="p-sidebar-md optionalFilterPanel"
    [baseZIndex]="0"
    [(visible)]="isSidebarOpen">
    <h1 class="iu-notification-center-title">
      {{ 'specificWindow.optionalFilters' | translate }}
    </h1>
    <div class="optionalFields">
      <ng-template #optional />
    </div>
  </p-sidebar>
</div>

<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    [angularStyle]="customFormModalBodyCss"
    [isModalDisplay]="displayFormUI"
    [title]="specificWindowTitle"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false, sourceComponent: this }})">
    <ng-template #vcrSpecific />
  </iu-modal-ui>
</div>
